export default {
  SEARCH_INVESTMENT_AGREEMENTS_REPOSITORY: Symbol.for('SEARCH_INVESTMENT_AGREEMENTS_REPOSITORY'),
  INVESTMENT_AGREEMENTS_STATE_MANAGER: Symbol.for('INVESTMENT_AGREEMENTS_STATE_MANAGER'),
  SEARCH_INVESTMENT_AGREEMENTS_QUERY: Symbol.for('SEARCH_INVESTMENT_AGREEMENTS_QUERY'),
  SEARCH_INVESTMENT_AGREEMENTS_ASYNC_QUERY: Symbol.for('SEARCH_INVESTMENT_AGREEMENTS_ASYNC_QUERY'),
};
